import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { type Role, ROLES } from "@/api/admins";
import { getAdminStoreState } from "@/stores";

const ProfilesLayout = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/profiles")({
  beforeLoad: () => {
    const { admin } = getAdminStoreState();

    const requiredPermissions: Role[] = [ROLES.super, ROLES.viewer, ROLES.clinician];

    if (!admin || !requiredPermissions.includes(admin.role)) {
      throw redirect({ to: "/$" });
    }
  },
  component: ProfilesLayout,
});
